import { createElement } from 'react';
import { v as ContentAlignment$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var ContentAlignment = function ContentAlignment(props) {
  return /*#__PURE__*/createElement(ContentAlignment$1, __assign({}, props));
};
ContentAlignment.displayName = 'ContentAlignment';

export { ContentAlignment };
